import { gql } from '@apollo/client';

import { fragmentRegistry } from '../../../graphql/fragmentRegistry';

fragmentRegistry.register(gql`
  fragment skillsFragment on JobSkillsType {
    skill {
      id
      name
    }
  }
`);

fragmentRegistry.register(gql`
  fragment hierarchicalJobCategoryFragment on HierarchicalJobCategory {
    id
    name
    leaves {
      name
      id
    }
    parents {
      name
      id
    }
  }
`);

fragmentRegistry.register(gql`
  fragment locationFragment on HierarchicalLocation {
    id
    name
    formattedName
    parents {
      id
      name
      formattedName
    }
  }
`);

fragmentRegistry.register(gql`
  fragment companyAddressFragment on CompanyAddress {
    id
    status
    companyId
    pointOfInterestId
    additionalAddressInfo
    locationId
    poi {
      id
      coordinate {
        latitude
        longitude
      }
      name
      addressLabel
      provider
    }
  }
`);

fragmentRegistry.register(gql`
  fragment jobScreeningQuestionFragment on JobScreeningQuestion {
    selectedQuestions
    documentAndCertificates {
      id
      name
    }
    introVideoPreferredLanguageDetail {
      code
      name
      translationKey
    }
    industries {
      id
      name
    }
    languages {
      code
      name
    }
    customQuestionPlainTexts @include(if: $isCustomPlainSQEnabled)
  }
`);

fragmentRegistry.register(gql`
  fragment jobDraftScreeningQuestionFragment on JobDraftScreeningQuestion {
    selectedQuestions
    introVideoPreferredLanguageDetail {
      code
      name
      translationKey
    }
    documentAndCertificates {
      id
      name
    }
    industries {
      id
      name
    }
    languages {
      code
      name
    }
    customQuestionPlainTexts @include(if: $isCustomPlainSQEnabled)
  }
`);

export const getJobByIdQuery = gql`
  query getJobById($jobId: String!, $isCustomPlainSQEnabled: Boolean!) {
    getJobById(id: $jobId) {
      salaries {
        CurrencyCode
        id
        maxAmount
        minAmount
        salaryMode
        salaryType
        paymentFrequency
      }
      CityId
      company {
        id
        verificationInfo {
          ...companyVerificationInfoFragment
        }
      }
      CountryCode
      creatorId
      jobExtensionDetails {
        extendExpiryInDays
      }
      HierarchicalJobCategoryId
      hierarchicalJobCategory {
        ...hierarchicalJobCategoryFragment
      }
      DistrictId
      location {
        ...locationFragment
      }
      companyAddress {
        ...companyAddressFragment
      }
      closedAt
      createdAt
      updatedAt
      expiryDate
      JobCategoryId
      acceptsForeignApplications
      descriptionJsonString
      id
      workArrangementOption
      numberOfHires
      shouldShowSalary
      status
      title
      type
      skills {
        ...skillsFragment
      }
      minYearsOfExperience
      maxYearsOfExperience
      shouldPublishOnLinkedin
      benefits {
        benefit
        title
      }
      interviewProcessJsonString
      receiverIds
      areMandatoryDetailsComplete
      country {
        name
        code
        isWhitelisted
      }
      city {
        id
        name
        CountryCode
      }
      educationLevel
      isHot
      isJobBoostEligible
      supplyClassification
      minAge
      maxAge
      gender
      unfilteredSkills {
        ...skillsFragment
      }
      isLocationRequiredForCandidate
      isResumeRequiredForCandidate
      isEducationRequiredForCandidate
      jobDeprioritizeInfo {
        isDeprioritized
      }
      applicationCountBreakdown {
        unread
      }
      maybeHaveArchivedApplications
      screeningQuestions {
        ...jobScreeningQuestionFragment
      }
      screeningQuestionsEnabled
      metadata {
        requiresWeekendHolidays
        workingDaysPerWeek
        workShifts
      }
      vipCandidateInformation {
        required {
          profilePic
        }
      }
      externalApplyURL
    }
  }
`;

export const getJobDraftByIdQuery = gql`
  query getJobDraftById(
    $jobDraftId: String!
    $isCustomPlainSQEnabled: Boolean!
  ) {
    getJobDraftById(id: $jobDraftId) {
      id
      CityId
      title
      type
      JobCategoryId
      workArrangementOption
      CountryCode
      CreatorId
      acceptsForeignApplications
      descriptionJsonString
      minYearsOfExperience
      maxYearsOfExperience
      skills {
        ...skillsFragment
      }
      salaries {
        CurrencyCode
        id
        maxAmount
        minAmount
        salaryMode
        salaryType
        paymentFrequency
      }
      HierarchicalJobCategoryId
      hierarchicalJobCategory {
        ...hierarchicalJobCategoryFragment
      }
      country {
        name
        code
        isWhitelisted
      }
      DistrictId
      location {
        ...locationFragment
      }
      companyAddress {
        ...companyAddressFragment
      }
      educationLevel
      minAge
      maxAge
      gender
      isLocationRequiredForCandidate
      isResumeRequiredForCandidate
      isEducationRequiredForCandidate
      shouldShowSalary
      screeningQuestions {
        ...jobDraftScreeningQuestionFragment
      }
      company {
        id
      }
      metadata {
        requiresWeekendHolidays
        workingDaysPerWeek
        workShifts
      }
      vipCandidateInformation {
        required {
          profilePic
        }
      }
      externalApplyURL
      benefits {
        benefit
        title
      }
    }
  }
`;
